module.exports = __webpack_public_path__ + "static/SoleMate-62b5c7234b3890ed5b87475e5d1d2286.pdf";